<template>
  <div class="navbar">
    <div class="right-menu">
      
      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <img :src="avatar ? imageUrl+avatar : 'static/images/default-avatar.png'" class="user-avatar">
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown" class="user-dropdown">
          <el-dropdown-item>
            <div class="nav-user">
              <div class="nav-userIcon">
                <img :src="avatar ? imageUrl+avatar : 'static/images/default-avatar.png'" class="user-avatar" width="40px" height="40px">
              </div>
              <div class="nav-userinfo">
                 <span class="morebold">{{name}}</span>
                <span>{{phone}}</span>
              </div>
            </div>
          </el-dropdown-item>
          <el-dropdown-item @click.native="handleUpdateName">
            <span style="display:block;"><i class="el-icon-postcard"></i>修改姓名</span>
          </el-dropdown-item>
          <el-dropdown-item @click.native="handleUpdatePwd">
            <span style="display:block;"><i class="el-icon-help"></i>修改密码</span>
          </el-dropdown-item>
          <el-dropdown-item divided @click.native="logout">
            <span style="display:block;"><i class="el-icon-switch-button"></i>退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      
    </div>
    <el-dialog title="修改密码" :visible.sync="dialogFormVisible" class="sys-dialog" width="30%" :modal-append-to-body="false">
      <el-form ref="pwdDataForm" :rules="rules" :model="temp" label-position="left" label-width="110px" style="margin: 15px">
        <el-form-item label="旧密码" prop="oldPwd" required>
          <el-input v-model="temp.oldPwd" :key="oldPwdType" auto-complete="on" @change="checkPwd" :type="oldPwdType"/>
          <span class="show-pwd" @click="showOldPwd">
            <svg-icon :icon-class="oldPwdType === 'password' ? 'eye' : 'eye-open'" />
          </span>
        </el-form-item>
        <el-form-item label="新密码" prop="newPwd">
          <el-input ref="newPwd" :key="newPwdType" auto-complete="on" v-model="temp.newPwd" @change="checkNewPwd" :type="newPwdType" />
          <span class="show-pwd" @click="showNewPwd">
            <svg-icon :icon-class="newPwdType === 'password' ? 'eye' : 'eye-open'" />
          </span>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPwd">
           <el-input v-model="temp.confirmPwd" :key="confirmPwdType" auto-complete="on" @change="checkConfirmPwd" :type="confirmPwdType"/>
           <span class="show-pwd" @click="showConfirmPwd">
            <svg-icon :icon-class="confirmPwdType === 'password' ? 'eye' : 'eye-open'" />
          </span>
        </el-form-item>
      </el-form>
      <div>
          <el-button type="primary" @click="updatePassword()">
            保存
          </el-button>
      </div>
    </el-dialog>

    <el-dialog title="修改姓名" :visible.sync="nameDialogFormVisible" :modal-append-to-body="false" class="sys-dialog" width="30%">
      <el-form ref="nameDataForm" :rules="nameRules" :model="tempName" label-position="left" label-width="110px" style="margin: 15px">
        <el-form-item label="用户名" prop="userName" required>
          <el-input v-model="tempName.userName" />
        </el-form-item>
      </el-form>
      <div>
          <el-button type="primary" @click="updateUserName()">
            保存
          </el-button>
      </div>
    </el-dialog>

    <el-dialog title="修改手机号" :visible.sync="phoneDialogFormVisible" :modal-append-to-body="false" class="sys-dialog" width="30%">
      <el-form ref="phoneDataForm" :rules="phoneRules" :model="tempPhone" label-position="left" label-width="110px" style="margin: 15px">
        <el-form-item label="手机号" prop="userPhone" required>
          <el-input v-model="tempPhone.userPhone" />
        </el-form-item>
         <el-form-item label="验证码" prop="code" required>
              <el-input v-model="tempPhone.code" />
              <span class="show-code" @click="send">
              {{ countDown }}
              </span>
            </el-form-item>
        <el-form-item label="密码" prop="userPwd" required>
          <el-input v-model="tempPhone.userPwd" />
        </el-form-item>
      </el-form>
      <div>
          <el-button type="primary" @click="updateUserPhone()">
            保存
          </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import  * as userApi from '@/api/user'
import  * as messageApi from '@/api/message'
export default {
  data() {
    return {
      dialogFormVisible: false,
      nameDialogFormVisible: false,
      phoneDialogFormVisible: false,
      temp:{
        oldPwd: '',
        newPwd: '',
        confirmPwd: ''
      },
      tempName:{
        userName: ''
      },
      tempPhone:{
        userPhone: '',
        userPwd: ''
      },
      rules: {
          oldPwd: [{ required: true, message: '旧密码不能为空', trigger: 'blur' }],
          newPwd: [{ required: true, message: '新密码不能为空', trigger: 'blur' }],
          confirmPwd: [{ required: true, message: '确认密码不能为空', trigger: 'blur' }]
      },
      nameRules: {
          userName: [{ required: true, message: '用户名不能为空', trigger: 'blur' }]
      },
      phoneRules: {
          userPhone: [{ required: true, message: '手机号不能为空', trigger: 'blur' }],
          code: [{ required: true, message: '手机验证码不能为空', trigger: 'blur' }],
          userPwd: [{ required: true, message: '密码不能为空', trigger: 'blur' }]
      },
      notRead: 0,
      countDown: "发送验证码", // 倒计时
      bVerification: false, // 节流
      oldPwdType: 'password',
      newPwdType: 'password',
      confirmPwdType: 'password'
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'name',
      'phone',
    ]),
    imageUrl() {
      return this.$store.state.settings.imageUrl
    }
  },
  created(){
   // this.getMessageList()
  },
  methods: {
    getMessageList(){
        messageApi.list(this.listQuery).then(response => {
            this.notRead = response.data.notRead
        })
      },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    goToMessage(){
      this.$router.push({path: `/message`});
      
    },
    async logout() {
      await this.$store.dispatch('user/logout')
      this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    },
    handleUpdatePwd(){
      this.dialogFormVisible = true
    },
    showOldPwd() {
      if (this.oldPwdType === 'password') {
        this.oldPwdType = ''
      } else {
        this.oldPwdType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.oldPwd.focus()
      })
    },
    showNewPwd() {
      if (this.newPwdType === 'password') {
        this.newPwdType = ''
      } else {
        this.newPwdType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.newPwd.focus()
      })
    },
    showConfirmPwd(){
      if (this.confirmPwdType === 'password') {
        this.confirmPwdType = ''
      } else {
        this.confirmPwdType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.confirmPwd.focus()
      })
    },
    checkPwd(event){
      let label = /^(?=.*\d)(?=.*[a-z])[a-zA-Z\d]{8,15}$/
      let regex = new RegExp(label);
      if(event == ''){
        this.$message.error('旧密码不能为空')
        return false
      }else if(event.length < 8 || event.length > 15){
        this.$message.error('请输⼊8~15位密码')
        return false
      }else if (!regex.test(event)) {
        this.$message.error('密码必须同时包含字母、数字和特殊字符其中三项且⾄少8位')
        return false
      }else{
        return true
      }
      this.temp.oldPwd = event
    },
    checkNewPwd(event){
      this.temp.newPwd = event
      let label = /^(?=.*\d)(?=.*[a-z])[a-zA-Z\d]{8,15}$/
      let regex = new RegExp(label);
      if(event == ''){
        this.$message.error('旧密码不能为空')
        return false
      }else if(event.length < 8 || event.length > 15){
        this.$message.error('请输⼊8~15位密码')
        return false
      }else if(event == this.temp.oldPwd){
        this.$message.error('新密码和旧密码不可以一样哦')
        return false
      }else if (!regex.test(event)) {
        this.$message.error('密码必须同时包含字母、数字和特殊字符其中三项且⾄少8位')
        return false
      }else{
        return true
      }
    },
    checkConfirmPwd(event){
      this.temp.confirmPwd = event
      //var regex = new RegExp("[^a-zA-Z0-9].{8,15}")
      let label = /^(?=.*\d)(?=.*[a-z])[a-zA-Z\d]{8,15}$/
      let regex = new RegExp(label);
      if(event == ''){
        this.$message.error('旧密码不能为空')
        return false
      }else if(event.length < 8 || event.length > 15){
        this.$message.error('请输⼊8~15位密码')
        return false
      }else if (!regex.test(event)) {
        this.$message.error('密码必须同时包含字母、数字和特殊字符其中三项且⾄少8位')
        return false
      }else if( this.temp.newPwd != this.temp.confirmPwd){
        this.$message.error('新密码和确认密码不一致')
        return false
      }else{
        return true
      }
    },
    updatePassword(){
      if(this.checkPwd(this.temp.oldPwd) && this.checkNewPwd(this.temp.newPwd) && this.checkConfirmPwd(this.temp.confirmPwd)){
        this.$refs['pwdDataForm'].validate((valid) => {
          if (valid) {
            if(this.temp.newPwd != this.temp.confirmPwd){
              this.$message.error('新密码和确认密码不一致')
            }else{
              const tempData = Object.assign({}, this.temp)
              userApi.modifyPwd(tempData).then((response) => {
                this.dialogFormVisible = false
                if(response.code == 2000){
                  this.$message.success('操作成功!')
                  this.logout()
                }else{
                    this.$message.error(response.msg)
                }
              })
            }
            
          }
        })
      }
    },
    handleUpdateName(){
      this.nameDialogFormVisible = true
      this.tempName.code = ''
      this.tempName.userPwd = ''
    },
    updateUserName(){
      this.$refs['nameDataForm'].validate((valid) => {
        if (valid) {
          const tempData = Object.assign({}, this.tempName)
          userApi.modifyName(tempData.userName).then((response) => {
            this.nameDialogFormVisible = false
            if(response.code == 2000){
              this.$message.success('操作成功!')
            }else{
                this.$message.error(response.msg)
            }
          })
        }
      })
    },
    handleUpdatePhone(){
      this.phoneDialogFormVisible = true
    },

    async send() {
      try {
        if (!/^\d{11}$/.test(this.tempPhone.userPhone)) return this.$toast("请先输入正确的手机号");
        if (this.bVerification) return;
        this.bVerification = true;
        
        let data =  await userApi.getCode({phone:this.tempPhone.userPhone, key:'modify'})
        if (data.code === 2000) {
            console.log('发送验证码...');
        }
        let countDown = 59;
        const auth_time = setInterval(() => {
            this.countDown = countDown--;
            if (this.countDown <= 0) {
                this.bVerification = false;
                this.countDown = "发送验证码";
                clearInterval(auth_time);
            }
        }, 1000);
        
      }catch(err) {
        console.log(err);
      }
    },
    updateUserPhone(){
      this.$refs['phoneDataForm'].validate((valid) => {
        if (valid) {
          const tempData = Object.assign({}, this.tempPhone)
          userApi.modifyPhone(tempData).then((response) => {
            this.phoneDialogFormVisible = false
            if(response.code == 2000){
              this.$message.success('操作成功!')
            }else{
                this.$message.error(response.msg)
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  overflow: hidden;
  width: 300px;
  position: absolute;
  right: 0;
  z-index: 1001;
  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;
    display: flex;
    &:focus {
      outline: none;
    }
    .message-show{
      position: relative;
      line-height: 68px;
      span.show-icon{
        font-size: 20px;
        cursor: pointer;
      }
      .message-num{
        position: absolute;
        top: 8px;
        font-size: 12px;
        width: 15px;
        height: 15px;
        border-radius: 5px;
        background-color: red;
        color: #fff;
        text-align: center;
        line-height: 15px;
      }
    }
    

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }

    .avatar-container {
      margin-right: 30px;
      margin-left: 30px;
      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
          margin-top: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
  
}
.nav-user{
    display: flex;
    .nav-userIcon{
      width: 60px;
      height: 60px;
    }
    .nav-userinfo span{
      display: block;
      line-height: 25px;
      font-size: 12px;
    }
    .nav-userinfo span.morebold{
      font-weight: bold;
      font-size: 15px;
    }
}
.show-code{
    position: absolute;
    right: 10px;
    cursor: pointer;
  }
  .show-code:hover{
    color: #2D8CF0;
  }
.show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: #889aa4;
    cursor: pointer;
    user-select: none;
  }
</style>
